module.exports = __webpack_public_path__ + "static/img/fax.18c029f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/fax.png
// module id = PtH1
// module chunks = 0